import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import store from './store';


declare var Articles: any;
declare var ShoppingCart: any;
declare var Session: any;
declare var SessionUtils: any;

const axios = require('axios');

@Component({
  components: {}
})

export default class App extends Vue {

    public isArticlePopupVisible: Boolean = false;

    public popupArticle: any = null;

    public articlePopupTitle: string = "";

    public isPackagePopupVisible: Boolean = false;

    public packageArticleViewModels: any = [];

    // Used by the Vue to bind the treeview items
    public items: any = [];

    // The actual articles visible in the browser right now
    public filteredArticles: any = [];

    //
    private articleFilter: any;

    // Added when we initialise, so we can easily find which category in the treeview was clicked
    public categories: { [id: number]: any; } = {};

    // Adds text message in search area when an article is added to the cart
    public selectedArticle: any = null;

    // The search text bound to the search textbox
    public search: any = "";

    // Added when we initialise, so we can easily filter
    public articles: any = [];

    // For the pricing
    public Currency: string = "";


    public caseSensitive: boolean = false;
    public open: any = [];
    public snackbar: boolean = false;
    public session: any = null;
    public categoryId: string = "";
    public itemsPerPage: number = 20;
    public country = "sv";
    public active: any = null;
    public query = null;


    public randomName: string = "A" + Math.random().toString();

    public files: any = {
      html: 'mdi-language-html5',
      js: 'mdi-nodejs',
      json: 'mdi-file-document-box-outline',
      md: 'mdi-markdown',
      pdf: 'mdi-file-pdf',
      png: 'mdi-file-image',
      txt: 'mdi-file-document-outline',
      xls: 'mdi-file-excel',
    };


    ///////////////////////////////////////////////////////////////////////////
    //
    ///////////////////////////////////////////////////////////////////////////
    public onError(error) {

        console.log('onError %o', error);
    }


    ///////////////////////////////////////////////////////////////////////////
    //
    ///////////////////////////////////////////////////////////////////////////
    public filterArticles(ids: Array<number>) {

        console.log('filterArticles by id %d', ids[0]);

        if (ids === null) {

            this.filteredArticles = this.categories[200].articles;

        } else {

            let category = this.categories[ids[0]];

            console.log('filterArticles found %d articles', category.articles.length);

            this.filteredArticles = category.articles;
        }
    }


    ///////////////////////////////////////////////////////////////////////////
    //
    ///////////////////////////////////////////////////////////////////////////
    public filterArticleByName() {

        this.articleFilter = new RegExp(this.search, 'i');

        this.filteredArticles = this.articles.filter(this.isValidArticle).slice(0, 10);
    }


    ///////////////////////////////////////////////////////////////////////////
    //
    ///////////////////////////////////////////////////////////////////////////
    public addToWebShop(article) {

      this.snackbar = true;

      this.selectedArticle = article;

      ShoppingCart.AddProductToShoppingCart(article);
    }


    ///////////////////////////////////////////////////////////////////////////
    //
    ///////////////////////////////////////////////////////////////////////////
    public isValidArticle(element) {

      if (element == null)
        return false;

      return this.articleFilter.test(element.ArticleNumber) || this.articleFilter.test(element.Description);
    }


    ///////////////////////////////////////////////////////////////////////////
    //
    ///////////////////////////////////////////////////////////////////////////
    public treeViewFilter(item, search, textKey) {

      const rex = new RegExp(search, 'i');
      
      return rex.test(item.name);
    }


    ///////////////////////////////////////////////////////////////////////////
    //
    ///////////////////////////////////////////////////////////////////////////
    public showDetails(article) {

        if(article.IsPackage == false) {

            this.popupArticle = article;

            this.articlePopupTitle = article.ArticleNumber + " " + article.Description;

            this.isArticlePopupVisible = true;
        }
        else {

            this.popupArticle = article;

            this.articlePopupTitle = article.ArticleNumber + " " + article.FullDescription;

            this.isArticlePopupVisible = true;
        }
    }
  
  
    ///////////////////////////////////////////////////////////////////////////
    //
    ///////////////////////////////////////////////////////////////////////////
    public showArticlesList(article) {

        console.log("showDetails package Id = " + article.baseid);

        axios
            .get(process.env.VUE_APP_API_URL + "api/fpackagearticles/" + Session.GetSessionToken() + "/" + article.baseid)
            .then(result => {

                console.log("showDetails package articles = " + result.data.length);

                let weight = 0;

                this.packageArticleViewModels = [];

                for (let index = 0; index != result.data.length; index++) {

                    let packageArticleViewModel = result.data[index];

                    if (packageArticleViewModel.ArticleNr == "TOTAL_WEIGHT") {

                        weight = packageArticleViewModel.Weight;
                    }
                    else {

                        packageArticleViewModel.Description = SessionUtils.GetTranslation("ARTICLE_NAME", packageArticleViewModel.ArticleNr, packageArticleViewModel.ArticleNr);

                        this.packageArticleViewModels.push(packageArticleViewModel);
                    }
                }

                this.articlePopupTitle = article.ArticleNumber + " " + article.FullDescription + " (" + weight + "kgs)";

                this.isPackagePopupVisible = true;
            })
            .catch(error => {

                console.log('Error for api/fpackagearticles %o', error);
            });
    }


    ///////////////////////////////////////////////////////////////////////////
    //
    ///////////////////////////////////////////////////////////////////////////
    public closeArticlePopup () {

        this.isArticlePopupVisible = false;
    }


    ///////////////////////////////////////////////////////////////////////////
    //
    ///////////////////////////////////////////////////////////////////////////
    public closePackagePopup () {

        this.isPackagePopupVisible = false;
    }


    ///////////////////////////////////////////////////////////////////////////
    // Summary : Called by vue (part of the lifecycle) when we are ready 
    //           to bind
    //
    ///////////////////////////////////////////////////////////////////////////
    public mounted(): void {

        console.log('mounted() has been triggered');

        (window as any).store = this;

        this.country = JSON.parse(window.sessionStorage.getItem("SessionViewModel")).CountryCode;

        this.Currency = JSON.parse(window.sessionStorage.getItem("SessionViewModel")).CurrencyCode;


        this.query = this.$route.query;

        this.loadCategories();


        if (this.query["ART"] != undefined) {

            let articleNr: string = this.query["ART"];

            this.search = articleNr;

            this.filterArticleByName();
        }
        else if (this.query["CAT"] != undefined) {

            let category: string = this.query["CAT"];

            this.filterArticles([parseInt(category)]);
        }

        Session.HideWaiting();

    }


    ///////////////////////////////////////////////////////////////////////////
    // Summary : Called by vue
    //
    ///////////////////////////////////////////////////////////////////////////
    public loadLandingArticles(): void {

        axios
            .get(process.env.VUE_APP_API_URL + "api/landingpagearticles/" + Session.GetSessionToken())
            .then(result => {

                let vueArticlesCategory = {

                    id: 1,
                    name: SessionUtils.GetTranslation("CONTROL_LABEL", "START", "Start"),
                    articles: []
                };

                this.categories[1] = vueArticlesCategory;

                for (let articleIndex = 0; articleIndex != result.data.length; articleIndex++) {

                    let articleViewModel = result.data[articleIndex];

                    let vueArticle = {

                        id: articleViewModel.Id,
                        ArticleNumber: articleViewModel.ArticleNr,
                        Description: SessionUtils.GetTranslation("ARTICLE_NAME", articleViewModel.ArticleNr, articleViewModel.ArticleNr),
                        Depth: articleViewModel.DefaultDepth,
                        Width: articleViewModel.DefaultWidth,
                        Height: articleViewModel.DefaultHeight,
                        Weight: articleViewModel.Weight,
                        Price: SessionUtils.GetPrice(articleViewModel.ArticleNr),
                        IsPackage: false,
                        CategoryId: 1
                    };

                    vueArticlesCategory.articles.push(vueArticle);
                }

                if(this.items.length == 0)
                  this.items.push(vueArticlesCategory);
                else
                    this.items.splice(0, 0, vueArticlesCategory);

                if (this.query["ART"] == undefined && this.query["CAT"] == undefined) 
                    this.filterArticles([1]);
            })
            .catch(error => {

                console.log('Error for api/landingpagearticles %o', error);
            });
    }


    ///////////////////////////////////////////////////////////////////////////
    // Summary : Populates this.items for binding in App.vue
    //
    ///////////////////////////////////////////////////////////////////////////
    public loadCategories(): void {

        this.loadLandingArticles();

        let vueArticlesCategory = {

            name: SessionUtils.GetTranslation("CONTROL_LABEL", "ARTICLES", "Articles"),
            children: []
        };

        let articleMappings: { [articleNr: string]: boolean; } = {};

        articleMappings["1308"] = false;
        articleMappings["1312"] = false;
        articleMappings["1316"] = false;
        articleMappings["1322"] = false;
        articleMappings["1326"] = false;
        articleMappings["1380"] = false;
        articleMappings["1382"] = false;

        let orderedCategories = Articles.GetOrderedCategories();

        for (let categoryIndex = 0; categoryIndex != orderedCategories.length; categoryIndex++) {

            let sessionCategory = orderedCategories[categoryIndex];

            let vueCategory = {

                id: parseInt(sessionCategory.CategoryName),
                name: SessionUtils.GetTranslation("CATEGORY", sessionCategory.CategoryName, sessionCategory.CategoryName),
                articles: []
            };

            this.categories[vueCategory.id] = vueCategory;

            for (let articleIndex = 0; articleIndex != sessionCategory.Articles.length; articleIndex++) {

                let sessionArticle = sessionCategory.Articles[articleIndex];

                let articleNr: string = sessionArticle.ArticleNr;

                if (articleNr == "2860-R" || articleNr == "2862-R")
                    continue;

                if (articleNr == "1380-110" || articleNr == "1380-120" || articleNr == "1380-152" || articleNr == "1380-178" ||
                    articleNr == "1380-110-R" || articleNr == "1380-120-R" || articleNr == "1380-152-R" || articleNr == "1380-178-R" ||
                    articleNr == "1382-110" || articleNr == "1382-120" || articleNr == "1382-152" || articleNr == "1382-178" ||
                    articleNr == "1308-784" || articleNr == "1312-997" || articleNr == "1316-1176" || articleNr == "1322-1398" || articleNr == "1326-1568") {

                    // What is the real article nr
                    articleNr = articleNr.substr(0, 4);

                    if (articleMappings[articleNr] == false)
                        articleMappings[articleNr] = true;
                    else
                        continue;
                }

                let vueArticle = {

                    id: sessionArticle.Id,
                    ArticleNumber: articleNr,
                    Description: SessionUtils.GetTranslation("ARTICLE_NAME", articleNr, articleNr),
                    Depth: sessionArticle.DefaultDepth,
                    Width: sessionArticle.DefaultWidth,
                    Height: sessionArticle.DefaultHeight,
                    Weight: sessionArticle.Weight,
                    Price: SessionUtils.GetPrice(articleNr),
                    IsPackage: false,
                    CategoryId: vueCategory.id
                };

                vueCategory.articles.push(vueArticle);

                this.articles.push(vueArticle);
            }

            vueArticlesCategory.children.push(vueCategory);
        }

        this.items = [vueArticlesCategory];

        this.loadPackageArticles();
    }


    ///////////////////////////////////////////////////////////////////////////
    // Summary : Called by vue
    //
    ///////////////////////////////////////////////////////////////////////////
    public loadPackageArticles(): void {

        axios
            .get(process.env.VUE_APP_API_URL + "api/packagearticles/" + Session.GetSessionToken())
            .then(result => {

                let vueArticlesCategory = {

                    name: SessionUtils.GetTranslation("CONTROL_LABEL", "PACKAGES", "F-Packages"),
                    children: []
                };

                for (let manIndex = 0; manIndex != result.data.length; manIndex++) {

                    let manufacturerCategory = result.data[manIndex];

                    manufacturerCategory.name = SessionUtils.GetTranslation("MANUFACTURERS", manufacturerCategory.name, manufacturerCategory.name);

                    vueArticlesCategory.children.push(manufacturerCategory);

                    this.categories[manufacturerCategory.id] = manufacturerCategory;

                    for (let modelIndex = 0; modelIndex != manufacturerCategory.children.length; modelIndex++) {

                        let modelCategory = manufacturerCategory.children[modelIndex];

                        modelCategory.name = SessionUtils.GetTranslation("MODELS", modelCategory.name, modelCategory.name);

                        this.categories[modelCategory.id] = modelCategory;

                        for (let articleIndex = 0; articleIndex != modelCategory.articles.length; articleIndex++) {

                            let articleViewModel = modelCategory.articles[articleIndex];

                            articleViewModel.Description = articleViewModel.ArticleNumber;
                            articleViewModel.FullDescription = SessionUtils.GetTranslation("FPACKAGE_DESCS", articleViewModel.ArticleNumber + "_" + articleViewModel.Position, articleViewModel.ArticleNumber);
                            articleViewModel.Model = modelCategory.name;
                            articleViewModel.PositionDescription = SessionUtils.GetTranslation("POSITION_TYPE", articleViewModel.Position, articleViewModel.Position);

                            this.articles.push(articleViewModel);
                        }
                    }
                }

                this.items.push(vueArticlesCategory);
            })
            .catch(error => {

                console.log('Error for api/landingpagearticles %o', error);
            });
    }


    ///////////////////////////////////////////////////////////////////////////
    // Summary : Used in App.vue to create the image URL for each article
    //
    ///////////////////////////////////////////////////////////////////////////
    public getImagePath(article: any) {

        if (article.IsPackage)
            return process.env.VUE_APP_IMAGES_URL + "/Images/FPackages/" + article.Position + "/" + article.ArticleNumber + ".jpg";
        else
            return process.env.VUE_APP_IMAGES_URL + "/Images/Articles/" + article.ArticleNumber + ".jpg";
    }
}